import './App.css';
import Home from './component/home/home';

function App() {
  return (
    <Home />
  );
}

export default App;
